import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import styles from './WhatsAppQR.module.css';

const WhatsAppQR = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);

  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const link = cleanPhone
    ? `https://wa.me/${cleanPhone}${message ? `?text=${encodeURIComponent(message)}` : ''}`
    : '';

  const handleGenerate = (e) => {
    e.preventDefault();
    if (cleanPhone.length < 8) {
      alert('Por favor ingresá un número de teléfono válido con código de país.');
      return;
    }
    setShowQR(true);
  };

  const handleReset = () => {
    setShowQR(false);
    setCopied(false);
  };

  const handleDownload = () => {
    const canvas = document.getElementById('whatsappQrCanvas');
    if (!canvas) return;
    const dataUrl = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = `whatsapp_qr_${cleanPhone}.png`;
    a.click();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      alert('No se pudo copiar el link');
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.headerRow}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          ← Volver
        </button>
      </div>

      <div className={styles.card}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Generador de QR para WhatsApp</h1>
          <p className={styles.subtitle}>
            Creá un código QR personalizado para que tus clientes te contacten al instante por WhatsApp.
          </p>
        </div>

        {!showQR ? (
          <form className={styles.form} onSubmit={handleGenerate}>
            <div className={styles.field}>
              <label htmlFor="phone">Número de teléfono</label>
              <input
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+5492616808087"
                className={styles.input}
                required
              />
              <small className={styles.hint}>Incluí el código de país (ej: +54 para Argentina).</small>
            </div>

            <div className={styles.field}>
              <label htmlFor="message">Mensaje predeterminado (opcional)</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Hola! Vi tu perfil en BY Raíces y me interesa..."
                className={styles.textarea}
                rows={4}
                maxLength={400}
              />
              <small className={styles.hint}>{message.length}/400 caracteres</small>
            </div>

            <button type="submit" className={styles.primaryBtn}>
              Generar QR
            </button>
          </form>
        ) : (
          <div className={styles.qrResult}>
            <div className={styles.qrFrame}>
              <QRCodeCanvas
                id="whatsappQrCanvas"
                value={link}
                size={280}
                includeMargin
                level="H"
              />
            </div>

            <div className={styles.linkBlock}>
              <span className={styles.linkLabel}>Link directo:</span>
              <a href={link} target="_blank" rel="noopener noreferrer" className={styles.link}>
                {link}
              </a>
            </div>

            <div className={styles.actionsRow}>
              <button onClick={handleDownload} className={styles.primaryBtn}>
                📥 Descargar PNG
              </button>
              <button onClick={handleCopy} className={styles.secondaryBtn}>
                {copied ? '✓ Copiado' : '🔗 Copiar link'}
              </button>
              <button onClick={handleReset} className={styles.ghostBtn}>
                ← Editar datos
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsAppQR;
